(function () {
	function initSliders() {
		const slider = new Swiper('.js-media-list', {
			...getSliderSettings,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			on: {
				init(swiper) {
					setTimeout(() => swiper.update(), 100);
				},
				slideChange(swiper) {
					swiper.update();
				},
			},
		});

		const subSlider = new Swiper('.js-media-sublist', {
			...getSubSliderProductSettings,
			on: {
				init(swiper) {
					setTimeout(() => swiper.update(), 100);
				},
			},
		});

		// Optional: force recalculation when pagination dots are clicked
		document.querySelectorAll('.swiper-pagination-bullet').forEach((dot) => {
			dot.addEventListener('click', () => {
				setTimeout(() => {
					slider.update();
					slider.slideTo(slider.activeIndex, 0);
				}, 50);
			});
		});
	}

	document.addEventListener('DOMContentLoaded', initSliders);
	document.addEventListener('shopify:section:load', initSliders);
})();
